// Drag thresholds for mobile peek/expand sheet gesture (FAA v2 spec).
// Any downward drag past PEEK_DISMISS_PX from peek dismisses the drawer;
// an expanded sheet needs to travel further (EXPANDED_COLLAPSE_PX) before it
// snaps back down to peek; any upward drag past EXPAND_PX promotes peek -> full.
export const EXPAND_PX = 40;

export const PEEK_DISMISS_PX = 40;

export const EXPANDED_COLLAPSE_PX = 80;
